import React, { useCallback } from 'react'

import { Button } from '@mui/material'
import {
  TableHeader,
  TableRow,
  FormTable,
  TableRowActions,
  TableDialogAction,
  ConfirmationDialog
} from '@front/squirtle'
import { hooks, I18n } from '@front/volcanion'

import Header from './Header'
import Row from './Row'

const TaxicounterSection = ({ commercial_package_id, record_id, ...props }) => {
  const handleCreate = useCallback(() =>
    window.open(`/taxicounter/create?commercialpackage_id=${commercial_package_id}`, '_blank')
    [commercial_package_id])
  const handleRowClick = useCallback((rowId, row) => window.open(`/taxicounter/${_.get(row, 'taxicounter.taxi_counter_id')}`), [])
  const [deleteTaxicounter] = hooks.useModelFunction('commercialpackagetaxicounter', 'delete')
  return (
    <>
      <Button
        color='primary'
        size='large'
        sx={{ fontSize: 'subtitle.fontSize' }}
        variant='outlined'
        onClick={handleCreate}
      >
        {I18n.t('taxicounter.add.short')}
      </Button>
      <ConfirmationDialog name={'taxicounter_delete'} onConfirm={async (state) => { await deleteTaxicounter({ id: _.get(state, 'row.id') }) }} />
      <FormTable
        model_name={'commercialpackagetaxicounter'}
        config={{
          forced_filter: { commercialpackage: commercial_package_id, taxicounter: { generic: true } },
          validate_filter: useCallback(() => !!commercial_package_id, [commercial_package_id]),
          watchers: [commercial_package_id],
          initial_filter: {},
          populate: [
            'taxicounter.pricing',
            'taxicounter.start_zone',
            'commercialpackage'
          ]
        }}
        loadOnMount={!!record_id}
        tableProps={{
          enableRowActions: true,
          allowEditMode: false,
          allowRowGenerate: false,
          onRowClick: handleRowClick
        }}
      >
        <TableHeader><Header /></TableHeader>
        <TableRow><Row /></TableRow>

        <TableRowActions>
          <TableDialogAction
            name="taxicounter_delete"
            label={I18n.t('action.delete')}
            getDialogExtra={({ row }) => ({ title: I18n.t('commercialpackage.confirm_delete_taxicounter', { name: _.get(row, 'taxicounter.name') }) })}
          />
        </TableRowActions>
      </FormTable>
    </>
  )
}

export default React.memo(TaxicounterSection)
